export const getCountry = (isKZ: boolean) => (isKZ ? 'Казахстане' : 'России');
